// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M17,0H1C0.4,0,0,0.4,0,1v16c0,0.6,0.4,1,1,1h8.6v-6.9H7.3V8.3h2.3v-2c-0.1-1,0.2-1.9,0.9-2.6s1.6-1.1,2.6-1
		c0.7,0,1.4,0,2.1,0.1v2.4h-1.4c-1.1,0-1.3,0.5-1.3,1.3v1.7h2.7l-0.4,2.7h-2.3v7H17c0.6,0,1-0.4,1-1l0,0V1C18,0.4,17.6,0,17,0z"
        transform="translate(3.000000, 3.000000)" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-facebook-square-DhAz4P8U.js.map
